import React from 'react';
import User from 'src/app/models/User';

interface Props {
  users: User[];
  loading: boolean;
  direction: 'asc' | 'desc';
  onToggleSort: () => void;
}

export default function UserTable({ users, loading, direction, onToggleSort }: Props) {
  return (
    <div className="table-responsive" style={{ overflowY: 'auto' }}>
      <table className="table align-middle" data-testid="user-list-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>
              <button className="btn btn-link p-0 text-muted" onClick={onToggleSort} aria-sort={direction === 'asc' ? 'ascending' : 'descending'}>
                Status {direction === 'asc' ? '↑' : '↓'}
              </button>
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading && <tr><td colSpan={5}>Loading...</td></tr>}
          {!loading && users.length === 0 && <tr><td colSpan={5}>No users found</td></tr>}
          {!loading && users.map((user) => (
            <tr key={user.id}>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td>{user.role || '-'}</td>
              <td>{user.status || '-'}</td>
              <td>{user.status === 'invited' ? 'Invitation actions' : '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
        </div>
  );
}
